import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "./config";

export const useWithdrawTenderProposal = (tenderId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      tenderProposalId,
      body,
    }: {
      tenderProposalId: number;
      body: any;
    }) =>
      axiosInstance.put(`tender-proposals/${tenderProposalId}/cancel`, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tender-detail", tenderId] });
    },
  });
};

export const useWithdrawQuotationProposal = (quotationId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      quotationProposalId,
      body,
    }: {
      quotationProposalId: number;
      body: any;
    }) =>
      axiosInstance.put(
        `quotation-proposals/${quotationProposalId}/cancel`,
        body
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["quotation-detail", quotationId],
      });
    },
  });
};
